import React from "react";
import { Switch, Row, Col, Collapse } from "antd";

const { Panel } = Collapse;

const UserProjectPermission = ({
  indexList,
  disabledState,
  additionalParameters,
}) => {
  return (
    <Collapse defaultActiveKey={["project_permissions_1"]} expandIconPosition="end">
      <Panel header="Project Permissions" key="project_permissions_1">
        <div className="is_form_2_a">
          {indexList.map((d) => (
            <div className="is_form_2_aa" key={d._id}>
              <Row>
                <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                  <label>
                    {d.hmg_name} - {d.project_name}
                  </label>
                </Col>

                <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                  <Row>
                    <Col xxl={3} xl={6} lg={6} sm={8}>
                      <Switch
                        disabled={disabledState}
                        defaultChecked={
                          !additionalParameters.not_allowed_project_list.includes(
                            d._id
                          )
                        }
                        onChange={(e) => {
                          additionalParameters.set_not_allowed_project_list(
                            d._id,
                            e
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </Panel>
    </Collapse>
  );
};

export default UserProjectPermission;
